module.exports = __webpack_public_path__ + "static/media/vasta.163be97b.mp3";